/* eslint-disable max-len */
// Color translation maps
export const DIFF_NWS = {
  959052: [149, 144, 82, 0],
  979356: [151, 147, 86, 10],
  "9c9a60": [156, 154, 96, 20],
  a3a067: [163, 160, 103, 40],
  a8a570: [168, 165, 112, 50],
  acac79: [172, 172, 121, 70],
  b1b182: [28, 33, 48, -175],
  b6b88c: [31, 37, 54, -155],
  bcbd93: [28, 33, 47, -145],
  c1c39c: [23, 27, 39, -115],
  cacdaa: [30, 33, 49, -95],
  cccfaf: [27, 30, 45, -85],
  cccfb3: [22, 23, 39, -65],
  c8ccb3: [12, 15, 32, -55],
  bfc3b3: [-2, 0, 23, -25],
  b8bdb3: [-14, -13, 14, -5],
  b5bab3: [-23, -21, 4, 0],
  acb3b3: [-35, -30, 0, 0],
  aaafb3: [-30, -29, 0, 0],
  a3aab3: [-35, -30, 0, 0],
  a0a8b3: [-31, -27, 0, 0],
  "9aa1b3": [-34, -32, 0, 0],
  "97a0b3": [-33, -29, 0, 0],
  "909ab3": [-31, -27, 0, 0],
  "939ab5": [-25, -25, 2, 0],
  "8791b1": [-35, -30, -2, 0],
  "838eb1": [-32, -28, -2, 0],
  "7c89af": [-36, -31, -4, 0],
  "7785ae": [-35, -28, -5, 0],
  "7080aa": [-39, -32, -9, 0],
  "6b7caa": [-40, -32, -9, 0],
  "5e72a7": [-46, -35, -12, 0],
  "566da3": [-45, -33, -14, 0],
  "5269a3": [-46, -35, -12, 0],
  "4b64a1": [-49, -37, -14, 0],
  "4660a0": [-46, -34, -12, 0],
  "4260a1": [-46, -32, -9, 0],
  "4467a5": [-30, -14, -3, 0],
  "4975ae": [-21, 3, 7, 0],
  "4d7cb1": [-17, 10, 10, 0],
  "508aba": [-6, 29, 23, 0],
  "5491bf": [2, 40, 28, 0],
  "599ec6": [14, 58, 37, 0],
  "5ba5ca": [21, 69, 42, 0],
  "60b3d4": [30, 86, 54, 0],
  "62bad8": [30, 83, 51, 0],
  "67c8df": [31, 90, 53, 0],
  "69cfe4": [28, 83, 51, 0],
  "67d6d6": [24, 83, 33, 0],
  "60d6c4": [16, 76, 10, 0],
  "52d6a1": [-4, 61, -34, 0],
  "4bd690": [-14, 56, -54, 0],
  "3bd66d": [-34, 42, -98, 0],
  "34d65b": [-44, 35, -121, 0],
  "11d116": [-81, 23, -194, 0],
  "0fcd16": [-88, 5, -201, 0],
  "0fc316": [-90, -12, -206, 0],
  "0fbf15": [-88, -23, -193, 0],
  "0fb613": [-81, -32, -177, 0],
  "0eb313": [-75, -35, -160, 0],
  "0eaa13": [-61, -44, -125, 0],
  "0ca511": [-54, -49, -109, 0],
  "0c9e11": [-40, -56, -74, 0],
  "0c9911": [-5, -59, -7, 0],
  "0c900f": [-5, -65, -7, 0],
  "0a8c0f": [-5, -60, -7, 0],
  "0a830e": [-5, -64, -8, 0],
  "0a800e": [-5, -60, -7, 0],
  "0a770c": [-5, -63, -7, 0],
  "08720c": [-6, -65, -7, 0],
  "086b0a": [-6, -63, -9, 0],
  "08660a": [-4, -63, -7, 0],
  "085d08": [-4, -65, -9, 0],
  "1c6708": [16, -50, -9, 0],
  "467c08": [58, -25, -7, 0],
  "5b8707": [81, -5, -8, 0],
  "839c05": [121, 21, -10, 0],
  "97a805": [141, 40, -9, 0],
  c1bc05: [183, 64, -7, 0],
  d6c603: [204, 79, -9, 0],
  ffe200: [247, 116, -12, 0],
  ffd800: [247, 109, -10, 0],
  ffc800: [247, 102, -10, 0],
  ffc300: [247, 102, -8, 0],
  ffb500: [227, 78, -8, 0],
  ffb000: [185, 52, -8, 0],
  ffa700: [164, 32, -7, 0],
  ff9e00: [124, 2, -5, 0],
  ff9300: [104, -21, -5, 0],
  ff8900: [83, -40, -5, 0],
  ff7f00: [41, -71, -3, 0],
  ff0000: [22, -209, -3, 0],
  f00000: [-15, -216, 0, 0],
  e90000: [-22, -211, 0, 0],
  db0000: [-36, -200, 0, 0],
  d40000: [-43, -186, 0, 0],
  c60000: [-57, -181, 0, 0],
  bf0000: [-64, -172, 0, 0],
  b10000: [-78, -167, 0, 0],
  aa0000: [-85, -158, 0, 0],
  "9a0000": [-101, -147, 0, 0],
  930000: [-108, -137, 0, 0],
  850000: [-122, -127, 0, 0],
  "7e0000": [-129, 0, 0, 0],
  700000: [-135, 0, 0, 0],
  ffffff: [22, 255, 255, 0],
  ffe9ff: [29, 233, 255, 0],
  ffdfff: [43, 223, 255, 0],
  ffc8ff: [50, 200, 255, 0],
  ffbdff: [57, 189, 255, 0],
  ffa8ff: [71, 168, 255, 0],
  ff9cff: [78, 156, 255, 0],
  ff75ff: [92, 117, 255, 0],
  fb6bfd: [97, 107, 253, 0],
  f656f6: [99, 86, 246, 0],
  f24bf4: [109, 75, 244, 0],
  ed36ef: [111, 54, 239, 0],
  e92aeb: [121, 42, 235, 0],
  e416e6: [-27, -233, -25, 0],
  e10ae2: [-30, -234, -29, 0],
  ac00fb: [-83, -223, -4, 0],
  a300f6: [-92, -212, -9, 0],
  "9300ef": [-108, -189, -16, 0],
  "8700e9": [-120, -179, -22, 0],
  "7900e2": [-134, -168, -29, 0],
  "7200dd": [-141, -145, -34, 0],
  "6200d6": [0, 0, 0, 0],
};
export const DIFF_VIRIDIS = {
  959052: [109, 21, -60, -102],
  979356: [112, 23, -56, -96],
  "9c9a60": [117, 29, -46, -90],
  a3a067: [124, 34, -39, -74],
  a8a570: [130, 38, -30, -69],
  acac79: [134, 44, -21, -53],
  b1b182: [139, 48, -12, -47],
  b6b88c: [145, 54, -2, -31],
  bcbd93: [151, 58, 6, -26],
  c1c39c: [157, 62, 15, -4],
  cacdaa: [166, 71, 29, 12],
  cccfaf: [169, 72, 34, 17],
  cccfb3: [169, 71, 38, 33],
  c8ccb3: [165, 67, 38, 39],
  bfc3b3: [157, 57, 38, 60],
  b8bdb3: [150, 50, 38, 76],
  b5bab3: [148, 46, 38, 77],
  acb3b3: [139, 38, 39, 73],
  aaafb3: [137, 33, 39, 68],
  a3aab3: [131, 27, 39, 64],
  a0a8b3: [128, 24, 39, 60],
  "9aa1b3": [122, 16, 39, 56],
  "97a0b3": [120, 14, 39, 51],
  "909ab3": [113, 7, 40, 47],
  "939ab5": [116, 6, 42, 43],
  "8791b1": [104, -4, 38, 39],
  "838eb1": [100, -8, 38, 34],
  "7c89af": [94, -14, 37, 30],
  "7785ae": [89, -19, 36, 26],
  "7080aa": [82, -25, 32, 22],
  "6b7caa": [77, -29, 32, 17],
  "5e72a7": [64, -41, 30, 9],
  "566da3": [56, -47, 26, 5],
  "5269a3": [52, -52, 27, 0],
  "4b64a1": [45, -58, 25, 0],
  "4660a0": [40, -63, 24, 0],
  "4260a1": [36, -64, 26, 0],
  "4467a5": [37, -58, 30, 0],
  "4975ae": [42, -45, 40, 0],
  "4d7cb1": [46, -39, 43, 0],
  "508aba": [48, -26, 53, 0],
  "5491bf": [52, -20, 58, 0],
  "599ec6": [56, -8, 65, 0],
  "5ba5ca": [58, -2, 70, 0],
  "60b3d4": [62, 12, 80, 0],
  "62bad8": [63, 18, 85, 0],
  "67c8df": [68, 31, 93, 0],
  "69cfe4": [69, 37, 98, 0],
  "67d6d6": [66, 43, 85, 0],
  "60d6c4": [58, 42, 67, 0],
  "52d6a1": [43, 41, 33, 0],
  "4bd690": [35, 40, 17, 0],
  "3bd66d": [18, 39, -18, 0],
  "34d65b": [10, 38, -35, 0],
  "11d116": [-26, 32, -103, 0],
  "0fcd16": [-29, 28, -103, 0],
  "0fc316": [-31, 17, -102, 0],
  "0fbf15": [-32, 12, -102, 0],
  "0fb613": [-33, 2, -103, 0],
  "0eb313": [-36, -2, -103, 0],
  "0eaa13": [-37, -12, -102, 0],
  "0ca511": [-41, -18, -103, 0],
  "0c9e11": [-42, -26, -102, 0],
  "0c9911": [-44, -32, -101, 0],
  "0c900f": [-45, -41, -103, 0],
  "0a8c0f": [-49, -46, -102, 0],
  "0a830e": [-51, -56, -102, 0],
  "0a800e": [-52, -60, -101, 0],
  "0a770c": [-54, -70, -102, 0],
  "08720c": [-58, -76, -101, 0],
  "086b0a": [-60, -83, -102, 0],
  "08660a": [-61, -89, -101, 0],
  "085d08": [-63, -99, -102, 0],
  "1c6708": [-45, -90, -101, 0],
  "467c08": [-5, -70, -100, 0],
  "5b8707": [14, -59, -100, 0],
  "839c05": [52, -39, -100, 0],
  "97a805": [70, -28, -99, 0],
  c1bc05: [110, -9, -98, 0],
  d6c603: [129, 0, -99, 0],
  ffe200: [168, 28, -101, 0],
  ffd800: [166, 17, -100, 0],
  ffc800: [164, 0, -98, 0],
  ffc300: [161, -6, -97, 0],
  ffb500: [159, -20, -96, 0],
  ffb000: [157, -26, -95, 0],
  ffa700: [155, -36, -93, 0],
  ff9e00: [152, -46, -92, 0],
  ff9300: [150, -57, -91, 0],
  ff8900: [148, -68, -89, 0],
  ff7f00: [146, -79, -88, 0],
  ff0000: [143, -206, -86, 0],
  f00000: [126, -207, -85, 0],
  e90000: [117, -208, -84, 0],
  db0000: [100, -208, -82, 0],
  d40000: [91, -209, -81, 0],
  c60000: [74, -210, -79, 0],
  bf0000: [65, -210, -78, 0],
  b10000: [48, -211, -76, 0],
  aa0000: [39, -211, -75, 0],
  "9a0000": [20, -212, -73, 0],
  930000: [11, -213, -71, 0],
  850000: [-6, -213, -70, 0],
  "7e0000": [-15, -214, -68, 0],
  700000: [-32, -214, -67, 0],
  ffffff: [109, 40, 190, 0],
  ffe9ff: [106, 18, 192, 0],
  ffdfff: [104, 7, 193, 0],
  ffc8ff: [101, -16, 195, 0],
  ffbdff: [98, -28, 197, 0],
  ffa8ff: [96, -49, 199, 0],
  ff9cff: [93, -62, 200, 0],
  ff75ff: [90, -101, 202, 0],
  fb6bfd: [84, -112, 202, 0],
  f656f6: [76, -133, 196, 0],
  f24bf4: [69, -145, 196, 0],
  ed36ef: [62, -166, 193, 0],
  e92aeb: [55, -179, 191, 0],
  e416e6: [47, -199, 187, 0],
  e10ae2: [42, -211, 185, 0],
  ac00fb: [-14, -222, 212, 0],
  a300f6: [-26, -222, 208, 0],
  "9300ef": [-44, -223, 203, 0],
  "8700e9": [-59, -223, 199, 0],
  "7900e2": [-76, -223, 193, 0],
  "7200dd": [-85, -224, 190, 0],
  "6200d6": [-155, -231, 178, 0],
};
export const DIFF_PYART_STEPSEQ = {
  959052: [-90, -2, -64, -110],
  979356: [-93, -9, -70, -104],
  "9c9a60": [-90, -7, -65, -99],
  a3a067: [-88, -11, -68, -83],
  a8a570: [-85, -11, -64, -77],
  acac79: [-78, -2, -49, -61],
  b1b182: [-54, 21, -10, -56],
  b6b88c: [-39, 37, 16, -40],
  bcbd93: [-14, 60, 53, -34],
  c1c39c: [11, 84, 93, -13],
  cacdaa: [39, 111, 138, 3],
  cccfaf: [50, 122, 158, 9],
  cccfb3: [47, 118, 159, 25],
  c8ccb3: [41, 113, 156, 30],
  bfc3b3: [24, 96, 148, 52],
  b8bdb3: [15, 88, 145, 68],
  b5bab3: [7, 79, 140, 68],
  acb3b3: [-4, 70, 137, 64],
  aaafb3: [-9, 63, 134, 60],
  a3aab3: [-20, 52, 127, 56],
  a0a8b3: [-26, 47, 124, 51],
  "9aa1b3": [-37, 34, 117, 47],
  "97a0b3": [-42, 31, 113, 43],
  "909ab3": [-51, 22, 110, 39],
  "939ab5": [-53, 16, 105, 34],
  "8791b1": [-68, 4, 97, 30],
  "838eb1": [-76, -6, 89, 26],
  "7c89af": [-86, -14, 83, 22],
  "7785ae": [-93, -21, 78, 17],
  "7080aa": [-105, -33, 65, 13],
  "6b7caa": [-112, -40, 61, 9],
  "5e72a7": [-133, -60, 45, 0],
  "566da3": [-143, -68, 37, 0],
  "5269a3": [-152, -80, 27, 0],
  "4b64a1": [-161, -88, 21, 0],
  "4660a0": [-171, -100, 10, 0],
  "4260a1": [-177, -103, 6, 0],
  "4467a5": [-178, -100, 5, 0],
  "4975ae": [-178, -93, 4, 0],
  "4d7cb1": [-176, -90, 2, 0],
  "508aba": [-155, -70, 29, 0],
  "5491bf": [-137, -57, 49, 0],
  "599ec6": [-119, -38, 72, 0],
  "5ba5ca": [-89, -19, 107, 0],
  "60b3d4": [-70, 1, 132, 0],
  "62bad8": [-40, 20, 167, 0],
  "67c8df": [-21, 40, 189, 0],
  "69cfe4": [-5, 53, 209, 0],
  "67d6d6": [-8, 57, 194, 0],
  "60d6c4": [-18, 55, 174, 0],
  "52d6a1": [-37, 50, 133, 0],
  "4bd690": [-46, 48, 113, 0],
  "3bd66d": [-65, 45, 76, 0],
  "34d65b": [-77, 40, 52, 0],
  "11d116": [-114, 33, -20, 0],
  "0fcd16": [-121, 24, -26, 0],
  "0fc316": [-124, 12, -30, 0],
  "0fbf15": [-127, 5, -34, 0],
  "0fb613": [-133, -8, -43, 0],
  "0eb313": [-136, -14, -46, 0],
  "0eaa13": [-142, -28, -53, 0],
  "0ca511": [-147, -35, -59, 0],
  "0c9e11": [-149, -44, -62, 0],
  "0c9911": [-155, -54, -70, 0],
  "0c900f": [-158, -66, -77, 0],
  "0a8c0f": [-166, -74, -85, 0],
  "0a830e": [-169, -86, -90, 0],
  "0a800e": [-172, -91, -94, 0],
  "0a770c": [-178, -105, -105, 0],
  "08720c": [-183, -112, -109, 0],
  "086b0a": [-189, -124, -120, 0],
  "08660a": [-193, -132, -125, 0],
  "085d08": [-196, -143, -132, 0],
  "1c6708": [-182, -138, -142, 0],
  "467c08": [-144, -119, -147, 0],
  "5b8707": [-129, -113, -157, 0],
  "839c05": [-92, -94, -164, 0],
  "97a805": [-76, -85, -169, 0],
  c1bc05: [-11, -49, -170, 0],
  d6c603: [30, -25, -170, 0],
  ffe200: [112, 31, -168, 0],
  ffd800: [132, 35, -165, 0],
  ffc800: [152, 33, -163, 0],
  ffc300: [192, 55, -158, 0],
  ffb500: [212, 55, -156, 0],
  ffb000: [238, 68, -154, 0],
  ffa700: [236, 56, -156, 0],
  ff9e00: [233, 45, -159, 0],
  ff9300: [227, 29, -164, 0],
  ff8900: [225, 16, -166, 0],
  ff7f00: [219, 1, -171, 0],
  ff0000: [216, -128, -173, 0],
  f00000: [199, -131, -176, 0],
  e90000: [185, -136, -180, 0],
  db0000: [168, -139, -183, 0],
  d40000: [154, -144, -188, 0],
  c60000: [136, -147, -190, 0],
  bf0000: [126, -150, -192, 0],
  b10000: [105, -155, -197, 0],
  aa0000: [95, -158, -200, 0],
  "9a0000": [71, -164, -204, 0],
  930000: [60, -167, -207, 0],
  850000: [42, -170, -209, 0],
  "7e0000": [27, -176, -214, 0],
  700000: [8, -179, -216, 0],
  ffffff: [143, 70, 34, 0],
  ffe9ff: [139, 45, 31, 0],
  ffdfff: [135, 32, 29, 0],
  ffc8ff: [126, 3, 24, 0],
  ffbdff: [121, -11, 22, 0],
  ffa8ff: [111, -39, 17, 0],
  ff9cff: [106, -54, 15, 0],
  ff75ff: [101, -96, 12, 0],
  fb6bfd: [87, -113, 5, 0],
  f656f6: [77, -137, -4, 0],
  f24bf4: [66, -151, -9, 0],
  ed36ef: [74, -152, -5, 0],
  e92aeb: [83, -144, 1, 0],
  e416e6: [104, -124, 15, 0],
  e10ae2: [115, -116, 21, 0],
  ac00fb: [88, -85, 65, 0],
  a300f6: [92, -65, 70, 0],
  "9300ef": [89, -45, 72, 0],
  "8700e9": [96, -16, 79, 0],
  "7900e2": [79, -19, 70, 0],
  "7200dd": [67, -24, 60, 0],
  "6200d6": [-93, -178, -41, 0],
};
export const DIFF_HOMEYER = {
  959052: [97, -20, -87, -110],
  979356: [94, -20, -82, -104],
  "9c9a60": [96, -15, -71, -99],
  a3a067: [98, -12, -62, -83],
  a8a570: [100, -8, -52, -77],
  acac79: [102, -3, -42, -61],
  b1b182: [102, -1, -31, -56],
  b6b88c: [104, 4, -20, -40],
  bcbd93: [105, 6, -11, -34],
  c1c39c: [105, 9, 0, -13],
  cacdaa: [109, 16, 16, 3],
  cccfaf: [108, 17, 23, 9],
  cccfb3: [103, 14, 28, 25],
  c8ccb3: [96, 9, 29, 30],
  bfc3b3: [79, -4, 32, 52],
  b8bdb3: [70, -11, 33, 68],
  b5bab3: [61, -17, 35, 68],
  acb3b3: [50, -26, 36, 64],
  aaafb3: [45, -31, 37, 60],
  a3aab3: [33, -39, 39, 56],
  a0a8b3: [27, -43, 40, 51],
  "9aa1b3": [16, -52, 42, 47],
  "97a0b3": [10, -55, 43, 43],
  "909ab3": [0, -62, 44, 39],
  "939ab5": [-2, -65, 48, 34],
  "8791b1": [-17, -76, 45, 30],
  "838eb1": [-26, -81, 47, 26],
  "7c89af": [-36, -88, 45, 22],
  "7785ae": [-44, -93, 45, 17],
  "7080aa": [-56, -101, 43, 13],
  "6b7caa": [-64, -106, 44, 9],
  "5e72a7": [-85, -121, 43, 0],
  "566da3": [-96, -127, 40, 0],
  "5269a3": [-105, -134, 42, 0],
  "4b64a1": [-115, -140, 40, 0],
  "4660a0": [-126, -147, 41, 0],
  "4260a1": [-132, -148, 43, 0],
  "4467a5": [-132, -142, 48, 0],
  "4975ae": [-131, -129, 60, 0],
  "4d7cb1": [-129, -122, 64, 0],
  "508aba": [-130, -109, 76, 0],
  "5491bf": [-128, -102, 83, 0],
  "599ec6": [-125, -90, 91, 0],
  "5ba5ca": [-127, -84, 98, 0],
  "60b3d4": [-124, -70, 109, 0],
  "62bad8": [-126, -64, 116, 0],
  "67c8df": [-123, -51, 124, 0],
  "69cfe4": [-123, -44, 131, 0],
  "67d6d6": [-129, -38, 120, 0],
  "60d6c4": [-138, -39, 103, 0],
  "52d6a1": [-152, -35, 74, 0],
  "4bd690": [-159, -34, 60, 0],
  "3bd66d": [-174, -32, 29, 0],
  "34d65b": [-181, -28, 17, 0],
  "11d116": [-216, -31, -49, 0],
  "0fcd16": [-217, -31, -42, 0],
  "0fc316": [-217, -39, -39, 0],
  "0fbf15": [-216, -41, -36, 0],
  "0fb613": [-216, -47, -32, 0],
  "0eb313": [-217, -48, -28, 0],
  "0eaa13": [-216, -53, -22, 0],
  "0ca511": [-218, -56, -21, 0],
  "0c9e11": [-218, -61, -17, 0],
  "0c9911": [-217, -62, -11, 0],
  "0c900f": [-217, -69, -11, 0],
  "0a8c0f": [-218, -69, -5, 0],
  "0a830e": [-218, -76, -3, 0],
  "0a800e": [-218, -77, 0, 0],
  "0a770c": [-217, -82, 3, 0],
  "08720c": [-219, -85, 6, 0],
  "086b0a": [-218, -88, 10, 0],
  "08660a": [-218, -91, 10, 0],
  "085d08": [-218, -98, 8, 0],
  "1c6708": [-197, -84, 8, 0],
  "467c08": [-155, -61, 8, 0],
  "5b8707": [-133, -46, 7, 0],
  "839c05": [-93, -23, 5, 0],
  "97a805": [-73, -9, 5, 0],
  c1bc05: [-30, 15, 5, 0],
  d6c603: [-9, 27, 3, 0],
  ffe200: [33, 59, 0, 0],
  ffd800: [33, 51, 0, 0],
  ffc800: [34, 37, 0, 0],
  ffc300: [34, 37, 0, 0],
  ffb500: [35, 25, 0, 0],
  ffb000: [35, 24, 0, 0],
  ffa700: [35, 17, 0, 0],
  ff9e00: [36, 10, 0, 0],
  ff9300: [36, 3, 0, 0],
  ff8900: [37, -5, 0, 0],
  ff7f00: [37, -10, 0, 0],
  ff0000: [38, -135, 0, 0],
  f00000: [23, -133, 0, 0],
  e90000: [17, -129, 0, 0],
  db0000: [3, -127, 0, 0],
  d40000: [-3, -122, 0, 0],
  c60000: [-17, -120, 0, 0],
  bf0000: [-23, -118, 0, 0],
  b10000: [-37, -114, 0, 0],
  aa0000: [-43, -111, 0, 0],
  "9a0000": [-58, -107, 0, 0],
  930000: [-65, -105, 0, 0],
  850000: [-79, -103, 0, 0],
  "7e0000": [-85, -98, 0, 0],
  700000: [-98, -96, 0, 0],
  ffffff: [46, 163, 255, 0],
  ffe9ff: [46, 144, 255, 0],
  ffdfff: [46, 136, 255, 0],
  ffc8ff: [47, 117, 255, 0],
  ffbdff: [48, 109, 255, 0],
  ffa8ff: [49, 92, 255, 0],
  ff9cff: [49, 82, 255, 0],
  ff75ff: [50, 45, 255, 0],
  fb6bfd: [47, 40, 253, 0],
  f656f6: [42, 21, 246, 0],
  f24bf4: [39, 15, 244, 0],
  ed36ef: [35, -4, 239, 0],
  e92aeb: [31, -14, 235, 0],
  e416e6: [27, -29, 230, 0],
  e10ae2: [25, -39, 226, 0],
  ac00fb: [-27, -44, 251, 0],
  a300f6: [-36, -42, 246, 0],
  "9300ef": [-51, -40, 239, 0],
  "8700e9": [-62, -35, 233, 0],
  "7900e2": [-75, -33, 226, 0],
  "7200dd": [-81, -28, 221, 0],
  "6200d6": [-68, 0, 214, 0],
};
export const DIFF_LANG = {
  959052: [-25, -29, -160, -110],
  979356: [-20, -25, -155, -104],
  "9c9a60": [-13, -17, -145, -99],
  a3a067: [-2, -9, -138, -83],
  a8a570: [4, -3, -129, -77],
  acac79: [10, 4, -120, -61],
  b1b182: [18, 11, -111, -56],
  b6b88c: [25, 19, -101, -40],
  bcbd93: [34, 24, -93, -34],
  c1c39c: [41, 29, -84, -13],
  cacdaa: [53, 38, -70, 3],
  cccfaf: [56, 40, -65, 9],
  cccfb3: [58, 40, -61, 25],
  c8ccb3: [56, 36, -61, 30],
  bfc3b3: [50, 26, -60, 52],
  b8bdb3: [44, 20, -60, 68],
  b5bab3: [44, 16, -60, 68],
  acb3b3: [36, 9, -60, 64],
  aaafb3: [35, 5, -60, 60],
  a3aab3: [31, -1, -60, 56],
  a0a8b3: [29, -3, -60, 51],
  "9aa1b3": [26, -11, -59, 47],
  "97a0b3": [24, -12, -59, 43],
  "909ab3": [18, -20, -59, 39],
  "939ab5": [24, -22, -57, 34],
  "8791b1": [13, -32, -61, 30],
  "838eb1": [11, -37, -61, 26],
  "7c89af": [6, -43, -63, 22],
  "7785ae": [2, -48, -64, 17],
  "7080aa": [-3, -55, -68, 13],
  "6b7caa": [-6, -60, -68, 9],
  "5e72a7": [-15, -73, -71, 0],
  "566da3": [-22, -79, -75, 0],
  "5269a3": [-24, -85, -74, 0],
  "4b64a1": [-29, -91, -76, 0],
  "4660a0": [-32, -97, -77, 0],
  "4260a1": [-35, -98, -76, 0],
  "4467a5": [-31, -92, -72, 0],
  "4975ae": [-24, -81, -63, 0],
  "4d7cb1": [-18, -76, -60, 0],
  "508aba": [-13, -65, -51, 0],
  "5491bf": [-8, -60, -46, 0],
  "599ec6": [-1, -49, -39, 0],
  "5ba5ca": [3, -45, -35, 0],
  "60b3d4": [10, -33, -25, 0],
  "62bad8": [14, -30, -21, 0],
  "67c8df": [20, -17, -14, 0],
  "69cfe4": [24, -12, -9, 0],
  "67d6d6": [24, -9, -23, 0],
  "60d6c4": [19, -10, -41, 0],
  "52d6a1": [7, -14, -76, 0],
  "4bd690": [2, -16, -93, 0],
  "3bd66d": [-13, -17, -128, 0],
  "34d65b": [-18, -21, -146, 0],
  "11d116": [-52, -28, -214, 0],
  "0fcd16": [-69, -32, -197, 0],
  "0fc316": [-76, -42, -188, 0],
  "0fbf15": [-83, -46, -181, 0],
  "0fb613": [-98, -55, -165, 0],
  "0eb313": [-106, -58, -157, 0],
  "0eaa13": [-120, -67, -140, 0],
  "0ca511": [-130, -72, -133, 0],
  "0c9e11": [-137, -79, -124, 0],
  "0c9911": [-152, -84, -107, 0],
  "0c900f": [-159, -93, -101, 0],
  "0a8c0f": [-175, -97, -83, 0],
  "0a830e": [-183, -106, -76, 0],
  "0a800e": [-190, -109, -67, 0],
  "0a770c": [-204, -118, -52, 0],
  "08720c": [-214, -123, -43, 0],
  "086b0a": [-228, -130, -28, 0],
  "08660a": [-229, -133, -27, 0],
  "085d08": [-228, -140, -28, 0],
  "1c6708": [-208, -127, -26, 0],
  "467c08": [-165, -104, -25, 0],
  "5b8707": [-144, -89, -24, 0],
  "839c05": [-103, -66, -25, 0],
  "97a805": [-83, -52, -24, 0],
  c1bc05: [-40, -28, -22, 0],
  d6c603: [-19, -16, -23, 0],
  ffe200: [23, 15, -24, 0],
  ffd800: [23, 7, -23, 0],
  ffc800: [24, -7, -22, 0],
  ffc300: [24, -8, -20, 0],
  ffb500: [25, -20, -19, 0],
  ffb000: [25, -21, -17, 0],
  ffa700: [26, -29, -16, 0],
  ff9e00: [26, -36, -15, 0],
  ff9300: [28, -42, -14, 0],
  ff8900: [29, -50, -14, 0],
  ff7f00: [31, -55, -14, 0],
  ff0000: [32, -180, -14, 0],
  f00000: [19, -177, -13, 0],
  e90000: [14, -173, -13, 0],
  db0000: [1, -170, -13, 0],
  d40000: [-4, -166, -12, 0],
  c60000: [-17, -163, -12, 0],
  bf0000: [-23, -161, -12, 0],
  b10000: [-34, -156, -12, 0],
  aa0000: [-40, -154, -11, 0],
  "9a0000": [-54, -149, -11, 0],
  930000: [-60, -147, -11, 0],
  850000: [-73, -144, -11, 0],
  "7e0000": [-78, -140, -10, 0],
  700000: [-90, -138, -10, 0],
  ffffff: [55, 121, 245, 0],
  ffe9ff: [56, 102, 245, 0],
  ffdfff: [57, 94, 246, 0],
  ffc8ff: [60, 75, 246, 0],
  ffbdff: [61, 66, 246, 0],
  ffa8ff: [63, 49, 246, 0],
  ff9cff: [64, 39, 247, 0],
  ff75ff: [65, 2, 247, 0],
  fb6bfd: [64, -4, 245, 0],
  f656f6: [60, -23, 238, 0],
  f24bf4: [58, -30, 237, 0],
  ed36ef: [54, -49, 232, 0],
  e92aeb: [51, -59, 228, 0],
  e416e6: [49, -75, 223, 0],
  e10ae2: [47, -85, 219, 0],
  ac00fb: [-4, -91, 245, 0],
  a300f6: [-12, -89, 240, 0],
  "9300ef": [-26, -87, 233, 0],
  "8700e9": [-36, -84, 227, 0],
  "7900e2": [-49, -82, 220, 0],
  "7200dd": [-53, -79, 216, 0],
  "6200d6": [-22, -21, 213, 0],
};
// (Partial) RVP6 Maps
export const RVP6_NWS = [[149, 144, 82, 255], [151, 147, 86, 255], [160, 156, 100, 255], [163, 160, 103, 255], [170, 168, 117, 255], [172, 172, 121, 255], [177, 177, 130, 255], [182, 184, 140, 255], [188, 189, 147, 255], [193, 195, 156, 255], [193, 195, 156, 255], [198, 202, 165, 255], [204, 207, 175, 255], [207, 209, 179, 255], [200, 204, 179, 255], [198, 200, 179, 255], [191, 195, 179, 255], [188, 193, 179, 255], [184, 189, 179, 255], [175, 181, 179, 255], [172, 179, 179, 255], [170, 175, 179, 255], [163, 170, 179, 255], [160, 168, 179, 255], [154, 161, 179, 255], [151, 160, 179, 255], [147, 156, 179, 255], [147, 154, 181, 255], [140, 149, 179, 255], [131, 142, 177, 255], [128, 140, 175, 255], [124, 137, 175, 255], [116, 130, 172, 255], [112, 128, 170, 255], [98, 117, 168, 255], [94, 114, 167, 255], [94, 114, 167, 255], [86, 109, 163, 255], [82, 105, 163, 255], [75, 100, 161, 255], [70, 96, 160, 255], [66, 93, 158, 255], [68, 103, 165, 255], [72, 110, 170, 255], [77, 124, 177, 255], [79, 131, 181, 255], [80, 138, 186, 255], [86, 153, 195, 255], [89, 158, 198, 255], [93, 172, 207, 255], [96, 179, 212, 255], [98, 186, 216, 255], [103, 200, 223, 255], [105, 207, 228, 255], [103, 214, 214, 255], [96, 214, 196, 255], [89, 214, 179, 255], [75, 214, 144, 255], [66, 214, 126, 255], [52, 214, 91, 255], [17, 212, 24, 255], [17, 209, 22, 255], [15, 200, 22, 255], [15, 195, 22, 255], [15, 188, 21, 255], [15, 182, 19, 255], [14, 179, 19, 255], [14, 170, 19, 255], [12, 165, 17, 255], [12, 158, 17, 255], [12, 153, 17, 255], [12, 149, 15, 255], [10, 140, 15, 255], [10, 135, 15, 255], [10, 128, 14, 255], [10, 124, 12, 255], [10, 119, 12, 255], [8, 110, 12, 255], [8, 107, 10, 255], [8, 98, 10, 255], [8, 93, 8, 255], [28, 103, 8, 255], [70, 124, 8, 255], [91, 135, 7, 255], [131, 156, 5, 255], [151, 168, 5, 255], [172, 177, 5, 255], [214, 198, 3, 255], [233, 209, 3, 255], [255, 216, 0, 255], [255, 211, 0, 255], [255, 200, 0, 255], [255, 186, 0, 255], [255, 181, 0, 255], [255, 172, 0, 255], [255, 167, 0, 255], [255, 158, 0, 255], [255, 147, 0, 255], [255, 137, 0, 255], [255, 127, 0, 255], [255, 0, 0, 255], [247, 0, 0, 255], [233, 0, 0, 255], [226, 0, 0, 255], [212, 0, 0, 255], [205, 0, 0, 255], [198, 0, 0, 255], [184, 0, 0, 255], [177, 0, 0, 255], [163, 0, 0, 255], [154, 0, 0, 255], [147, 0, 0, 255], [133, 0, 0, 255], [126, 0, 0, 255], [112, 0, 0, 255], [255, 255, 255, 255], [255, 244, 255, 255], [255, 223, 255, 255], [255, 212, 255, 255], [255, 189, 255, 255], [255, 179, 255, 255], [255, 168, 255, 255], [255, 145, 255, 255], [255, 117, 255, 255], [249, 96, 249, 255], [246, 86, 246, 255], [242, 75, 244, 255], [237, 54, 239, 255], [233, 42, 235, 255], [228, 22, 230, 255], [225, 10, 226, 255], [177, 0, 255, 255], [163, 0, 246, 255], [154, 0, 244, 255], [135, 0, 233, 255], [130, 0, 232, 255], [121, 0, 226, 255], [105, 0, 219, 255], [98, 0, 214, 255]];
export const RVP6_NWS_LEFTPAD = 62;
export const RVP6_CLASSIC = [[151, 147, 86, 10], [156, 154, 96, 20], [163, 160, 103, 40], [168, 165, 112, 50], [172, 172, 121, 70], [177, 177, 130, 80], [182, 184, 140, 100], [188, 189, 147, 110], [193, 195, 156, 130], [193, 195, 156, 140], [202, 205, 170, 160], [204, 207, 175, 170], [204, 207, 179, 190], [200, 204, 179, 200], [191, 195, 179, 220], [191, 195, 179, 230], [184, 189, 179, 250], [181, 186, 179, 255], [172, 179, 179, 255], [170, 175, 179, 255], [163, 170, 179, 255], [160, 168, 179, 255], [154, 161, 179, 255], [151, 160, 179, 255], [144, 154, 179, 255], [147, 154, 181, 255], [135, 145, 177, 255], [131, 142, 177, 255], [124, 137, 175, 255], [119, 133, 174, 255], [112, 128, 170, 255], [107, 124, 170, 255], [94, 114, 167, 255], [94, 114, 167, 255], [86, 109, 163, 255], [82, 105, 163, 255], [75, 100, 161, 255], [70, 96, 160, 255], [66, 96, 161, 255], [68, 103, 165, 255], [73, 117, 174, 255], [77, 124, 177, 255], [80, 138, 186, 255], [84, 145, 191, 255], [89, 158, 198, 255], [91, 165, 202, 255], [96, 179, 212, 255], [98, 186, 216, 255], [103, 200, 223, 255], [105, 207, 228, 255], [103, 214, 214, 255], [96, 214, 196, 255], [82, 214, 161, 255], [75, 214, 144, 255], [59, 214, 109, 255], [52, 214, 91, 255], [17, 209, 22, 255], [15, 205, 22, 255], [15, 195, 22, 255], [15, 191, 21, 255], [15, 182, 19, 255], [14, 179, 19, 255], [14, 170, 19, 255], [12, 165, 17, 255], [12, 158, 17, 255], [12, 153, 17, 255], [12, 144, 15, 255], [10, 140, 15, 255], [10, 131, 14, 255], [10, 128, 14, 255], [10, 119, 12, 255], [8, 114, 12, 255], [8, 107, 10, 255], [8, 102, 10, 255], [8, 93, 8, 255], [28, 103, 8, 255], [70, 124, 8, 255], [91, 135, 7, 255], [131, 156, 5, 255], [151, 168, 5, 255], [193, 188, 5, 255], [214, 198, 3, 255], [255, 226, 0, 255], [255, 216, 0, 255], [255, 200, 0, 255], [255, 195, 0, 255], [255, 181, 0, 255], [255, 176, 0, 255], [255, 167, 0, 255], [255, 158, 0, 255], [255, 147, 0, 255], [255, 137, 0, 255], [255, 127, 0, 255], [255, 0, 0, 255], [240, 0, 0, 255], [233, 0, 0, 255], [219, 0, 0, 255], [212, 0, 0, 255], [198, 0, 0, 255], [191, 0, 0, 255], [177, 0, 0, 255], [170, 0, 0, 255], [154, 0, 0, 255], [147, 0, 0, 255], [133, 0, 0, 255], [126, 0, 0, 255], [112, 0, 0, 255], [255, 255, 255, 255], [255, 233, 255, 255], [255, 223, 255, 255], [255, 200, 255, 255], [255, 189, 255, 255], [255, 168, 255, 255], [255, 156, 255, 255], [255, 117, 255, 255], [251, 107, 253, 255], [246, 86, 246, 255], [242, 75, 244, 255], [237, 54, 239, 255], [233, 42, 235, 255], [228, 22, 230, 255], [225, 10, 226, 255], [172, 0, 251, 255], [163, 0, 246, 255], [147, 0, 239, 255], [135, 0, 233, 255], [121, 0, 226, 255], [114, 0, 221, 255], [98, 0, 214, 255]];
export const RVP6_CLASSIC_LEFTPAD = 57;
export const RVP6_VIRIDIS = [[49, 100, 141, 0], [49, 101, 141, 4], [49, 102, 141, 8], [48, 103, 141, 12], [48, 104, 141, 17], [47, 105, 141, 21], [47, 106, 141, 25], [46, 107, 142, 29], [46, 108, 142, 34], [46, 109, 142, 38], [45, 110, 142, 42], [45, 111, 142, 46], [44, 112, 142, 51], [44, 113, 142, 55], [44, 114, 142, 59], [43, 115, 142, 63], [43, 116, 142, 68], [42, 117, 142, 72], [42, 118, 142, 76], [42, 119, 142, 80], [41, 120, 142, 85], [41, 121, 142, 89], [40, 122, 142, 93], [40, 122, 142, 97], [40, 123, 142, 102], [39, 124, 142, 106], [39, 125, 142, 110], [39, 126, 142, 114], [38, 127, 142, 119], [38, 128, 142, 123], [38, 129, 142, 127], [37, 130, 142, 131], [37, 131, 141, 136], [36, 132, 141, 140], [36, 133, 141, 144], [36, 134, 141, 148], [35, 135, 141, 153], [35, 136, 141, 157], [35, 137, 141, 161], [34, 137, 141, 165], [34, 138, 141, 170], [34, 139, 141, 174], [33, 140, 141, 178], [33, 141, 140, 182], [33, 142, 140, 187], [32, 143, 140, 191], [32, 144, 140, 195], [32, 145, 140, 199], [31, 146, 140, 204], [31, 147, 139, 208], [31, 148, 139, 212], [31, 149, 139, 216], [31, 150, 139, 221], [30, 151, 138, 225], [30, 152, 138, 229], [30, 153, 138, 233], [30, 153, 138, 238], [30, 154, 137, 242], [30, 155, 137, 246], [30, 156, 137, 250], [30, 157, 136, 255], [30, 158, 136, 255], [30, 159, 136, 255], [30, 160, 135, 255], [31, 161, 135, 255], [31, 162, 134, 255], [31, 163, 134, 255], [32, 164, 133, 255], [32, 165, 133, 255], [33, 166, 133, 255], [33, 167, 132, 255], [34, 167, 132, 255], [35, 168, 131, 255], [35, 169, 130, 255], [36, 170, 130, 255], [37, 171, 129, 255], [38, 172, 129, 255], [39, 173, 128, 255], [40, 174, 127, 255], [41, 175, 127, 255], [42, 176, 126, 255], [43, 177, 125, 255], [44, 177, 125, 255], [46, 178, 124, 255], [47, 179, 123, 255], [48, 180, 122, 255], [50, 181, 122, 255], [51, 182, 121, 255], [53, 183, 120, 255], [54, 184, 119, 255], [56, 185, 118, 255], [57, 185, 118, 255], [59, 186, 117, 255], [61, 187, 116, 255], [62, 188, 115, 255], [64, 189, 114, 255], [66, 190, 113, 255], [68, 190, 112, 255], [69, 191, 111, 255], [71, 192, 110, 255], [73, 193, 109, 255], [75, 194, 108, 255], [77, 194, 107, 255], [79, 195, 105, 255], [81, 196, 104, 255], [83, 197, 103, 255], [85, 198, 102, 255], [87, 198, 101, 255], [89, 199, 100, 255], [91, 200, 98, 255], [94, 201, 97, 255], [96, 201, 96, 255], [98, 202, 95, 255], [100, 203, 93, 255], [103, 204, 92, 255], [105, 204, 91, 255], [107, 205, 89, 255], [109, 206, 88, 255], [112, 206, 86, 255], [114, 207, 85, 255], [116, 208, 84, 255], [119, 208, 82, 255], [121, 209, 81, 255], [124, 210, 79, 255], [126, 210, 78, 255], [129, 211, 76, 255], [131, 211, 75, 255], [134, 212, 73, 255], [136, 213, 71, 255], [139, 213, 70, 255], [141, 214, 68, 255], [144, 214, 67, 255], [146, 215, 65, 255], [149, 215, 63, 255], [151, 216, 62, 255], [154, 216, 60, 255], [157, 217, 58, 255], [159, 217, 56, 255], [162, 218, 55, 255], [165, 218, 53, 255], [167, 219, 51, 255], [170, 219, 50, 255], [173, 220, 48, 255], [175, 220, 46, 255], [178, 221, 44, 255], [181, 221, 43, 255], [183, 221, 41, 255], [186, 222, 39, 255], [189, 222, 38, 255], [191, 223, 36, 255], [194, 223, 34, 255], [197, 223, 33, 255], [199, 224, 31, 255], [202, 224, 30, 255], [205, 224, 29, 255], [207, 225, 28, 255], [210, 225, 27, 255], [212, 225, 26, 255], [215, 226, 25, 255], [218, 226, 24, 255], [220, 226, 24, 255], [223, 227, 24, 255], [225, 227, 24, 255], [228, 227, 24, 255], [231, 228, 25, 255], [233, 228, 25, 255], [236, 228, 26, 255], [238, 229, 27, 255], [241, 229, 28, 255], [243, 229, 30, 255], [246, 230, 31, 255], [248, 230, 33, 255], [250, 230, 34, 255], [253, 231, 36, 255]];
export const RVP6_VIRIDIS_LEFTPAD = 32;
export const RVP6_PYART_STEPSEQ = [[153, 15, 15, 0], [155, 18, 18, 4], [160, 23, 23, 8], [162, 26, 26, 12], [167, 31, 31, 17], [169, 34, 34, 21], [172, 37, 37, 25], [177, 42, 42, 29], [179, 45, 45, 34], [184, 52, 52, 38], [186, 56, 56, 42], [189, 59, 59, 46], [193, 66, 66, 51], [196, 70, 70, 55], [201, 77, 77, 59], [203, 80, 80, 63], [205, 84, 84, 68], [210, 93, 93, 72], [213, 97, 97, 76], [217, 105, 105, 80], [220, 109, 109, 85], [222, 114, 114, 89], [227, 122, 122, 93], [229, 126, 126, 97], [234, 136, 136, 102], [237, 141, 141, 106], [239, 146, 146, 110], [244, 156, 156, 114], [246, 161, 161, 119], [251, 171, 171, 123], [253, 176, 176, 127], [250, 174, 170, 131], [231, 156, 140, 136], [221, 147, 124, 140], [202, 129, 94, 144], [192, 120, 78, 148], [182, 111, 63, 153], [163, 94, 32, 157], [154, 85, 17, 161], [157, 89, 20, 165], [159, 91, 23, 170], [162, 94, 25, 174], [167, 99, 31, 178], [169, 101, 34, 182], [174, 107, 39, 187], [176, 109, 42, 191], [179, 112, 45, 195], [183, 118, 52, 199], [186, 121, 55, 204], [191, 127, 62, 208], [193, 129, 66, 212], [195, 132, 69, 216], [200, 138, 76, 221], [203, 141, 80, 225], [207, 148, 88, 229], [210, 151, 92, 233], [212, 154, 96, 238], [217, 161, 105, 242], [219, 164, 109, 246], [224, 171, 117, 250], [227, 174, 122, 255], [229, 177, 126, 255], [234, 185, 136, 255], [236, 188, 140, 255], [241, 196, 150, 255], [243, 199, 155, 255], [246, 203, 160, 255], [251, 210, 170, 255], [253, 214, 175, 255], [235, 208, 157, 255], [221, 202, 142, 255], [208, 196, 126, 255], [180, 184, 95, 255], [166, 178, 80, 255], [138, 166, 49, 255], [124, 160, 34, 255], [110, 154, 19, 255], [111, 157, 20, 255], [114, 159, 22, 255], [119, 164, 28, 255], [121, 166, 31, 255], [124, 169, 33, 255], [129, 174, 39, 255], [131, 176, 42, 255], [136, 181, 48, 255], [139, 183, 52, 255], [142, 186, 55, 255], [148, 190, 62, 255], [150, 193, 65, 255], [156, 198, 72, 255], [159, 200, 76, 255], [161, 202, 79, 255], [167, 207, 87, 255], [170, 210, 92, 255], [176, 214, 100, 255], [179, 217, 104, 255], [182, 219, 108, 255], [188, 224, 117, 255], [191, 226, 121, 255], [197, 231, 130, 255], [201, 234, 135, 255], [204, 236, 140, 255], [210, 241, 150, 255], [214, 243, 155, 255], [220, 248, 164, 255], [223, 250, 169, 255], [227, 253, 174, 255], [204, 237, 175, 255], [184, 223, 173, 255], [143, 195, 168, 255], [123, 181, 165, 255], [103, 167, 163, 255], [63, 140, 158, 255], [43, 126, 156, 255], [17, 108, 154, 255], [19, 111, 156, 255], [22, 113, 159, 255], [28, 118, 164, 255], [30, 121, 166, 255], [36, 126, 171, 255], [39, 128, 173, 255], [41, 131, 176, 255], [48, 136, 180, 255], [51, 139, 183, 255], [58, 144, 188, 255], [62, 147, 190, 255], [65, 150, 192, 255], [72, 155, 197, 255], [75, 158, 200, 255], [83, 164, 204, 255], [87, 167, 207, 255], [91, 170, 209, 255], [99, 176, 214, 255], [104, 179, 216, 255], [112, 185, 221, 255], [116, 188, 224, 255], [120, 191, 226, 255], [129, 197, 231, 255], [134, 200, 233, 255], [144, 207, 238, 255], [149, 210, 240, 255], [154, 213, 243, 255], [164, 220, 248, 255], [169, 223, 250, 255], [176, 226, 253, 255], [163, 206, 244, 255], [150, 186, 234, 255], [124, 146, 215, 255], [110, 126, 205, 255], [84, 85, 186, 255], [71, 65, 176, 255], [58, 45, 167, 255], [39, 16, 154, 255], [42, 19, 156, 255], [47, 24, 161, 255], [50, 27, 163, 255], [53, 30, 166, 255], [58, 36, 171, 255], [61, 38, 173, 255], [66, 44, 178, 255], [69, 47, 180, 255], [73, 51, 183, 255], [79, 58, 187, 255], [82, 61, 190, 255], [89, 68, 195, 255], [92, 72, 197, 255], [96, 75, 199, 255], [102, 82, 204, 255], [106, 86, 207, 255], [114, 95, 211, 255], [118, 99, 214, 255], [122, 103, 216, 255], [130, 112, 221, 255], [134, 116, 223, 255], [141, 124, 228, 255], [146, 129, 231, 255], [150, 134, 233, 255], [159, 144, 238, 255], [164, 148, 240, 255], [173, 158, 245, 255], [177, 163, 247, 255], [182, 168, 250, 255], [191, 178, 255, 255]];
export const RVP6_PYART_STEPSEQ_LEFTPAD = 30;
export const RVP6_HOMEYER = [[0, 108, 198, 0], [0, 109, 197, 4], [0, 112, 196, 8], [0, 114, 195, 12], [0, 117, 194, 17], [0, 119, 193, 21], [0, 120, 192, 25], [0, 124, 191, 29], [0, 125, 190, 34], [0, 128, 189, 38], [0, 130, 188, 42], [2, 132, 188, 46], [6, 135, 186, 51], [9, 136, 186, 55], [13, 139, 184, 59], [16, 141, 183, 63], [18, 143, 182, 68], [23, 146, 180, 72], [26, 147, 179, 76], [30, 150, 178, 80], [33, 152, 177, 85], [35, 153, 176, 89], [40, 157, 174, 93], [43, 158, 173, 97], [47, 161, 171, 102], [50, 163, 170, 106], [52, 164, 169, 110], [57, 167, 168, 114], [60, 169, 167, 119], [65, 172, 165, 123], [68, 173, 164, 127], [70, 175, 163, 131], [75, 178, 161, 136], [78, 180, 160, 140], [83, 183, 158, 144], [86, 184, 157, 148], [88, 186, 156, 153], [93, 189, 154, 157], [96, 190, 152, 161], [101, 193, 151, 165], [104, 195, 150, 170], [106, 196, 149, 174], [112, 199, 147, 178], [114, 200, 146, 182], [120, 203, 144, 187], [122, 205, 143, 191], [125, 206, 142, 195], [130, 209, 140, 199], [133, 211, 139, 204], [138, 213, 137, 208], [141, 215, 136, 212], [144, 216, 135, 216], [149, 219, 133, 221], [152, 221, 132, 225], [157, 223, 130, 229], [160, 225, 130, 233], [163, 226, 129, 238], [168, 229, 127, 242], [171, 230, 126, 246], [176, 233, 125, 250], [179, 235, 124, 255], [182, 236, 123, 255], [187, 239, 121, 255], [190, 240, 121, 255], [196, 243, 119, 255], [198, 244, 118, 255], [200, 245, 117, 255], [204, 246, 114, 255], [206, 246, 113, 255], [210, 247, 110, 255], [212, 247, 108, 255], [214, 248, 107, 255], [218, 249, 104, 255], [220, 249, 103, 255], [224, 250, 100, 255], [226, 251, 99, 255], [228, 251, 97, 255], [232, 252, 94, 255], [234, 253, 93, 255], [234, 249, 87, 255], [234, 248, 84, 255], [233, 246, 80, 255], [233, 242, 74, 255], [233, 240, 71, 255], [232, 236, 64, 255], [232, 234, 61, 255], [231, 232, 57, 255], [231, 229, 51, 255], [231, 227, 47, 255], [230, 223, 41, 255], [230, 221, 38, 255], [230, 219, 34, 255], [229, 215, 28, 255], [229, 213, 26, 255], [228, 209, 20, 255], [228, 207, 17, 255], [228, 205, 14, 255], [227, 201, 9, 255], [227, 199, 6, 255], [226, 195, 0, 255], [226, 193, 0, 255], [226, 191, 0, 255], [225, 187, 0, 255], [225, 185, 0, 255], [224, 181, 0, 255], [224, 179, 0, 255], [224, 177, 0, 255], [223, 173, 0, 255], [223, 171, 0, 255], [222, 167, 0, 255], [222, 165, 0, 255], [221, 163, 0, 255], [221, 158, 0, 255], [220, 156, 0, 255], [220, 152, 0, 255], [220, 150, 0, 255], [219, 148, 0, 255], [219, 144, 0, 255], [218, 142, 0, 255], [218, 137, 0, 255], [217, 135, 0, 255], [217, 133, 0, 255], [216, 129, 0, 255], [216, 127, 0, 255], [215, 122, 0, 255], [215, 120, 0, 255], [214, 118, 0, 255], [214, 114, 0, 255], [213, 111, 0, 255], [212, 107, 0, 255], [212, 105, 0, 255], [212, 103, 0, 255], [211, 98, 0, 255], [210, 96, 0, 255], [209, 92, 0, 255], [209, 89, 0, 255], [209, 87, 0, 255], [208, 83, 0, 255], [207, 80, 0, 255], [206, 76, 0, 255], [206, 74, 0, 255], [205, 72, 0, 255], [204, 67, 0, 255], [204, 65, 0, 255], [203, 60, 0, 255], [202, 58, 0, 255], [202, 56, 0, 255], [201, 51, 0, 255], [200, 49, 0, 255], [199, 44, 0, 255], [199, 42, 0, 255], [198, 40, 0, 255], [197, 35, 0, 255], [196, 33, 0, 255], [195, 28, 0, 255], [195, 26, 0, 255], [194, 24, 0, 255], [193, 19, 0, 255], [192, 17, 0, 255], [191, 12, 0, 255], [190, 10, 0, 255], [189, 8, 0, 255], [188, 3, 0, 255], [187, 1, 0, 255], [186, 0, 0, 255], [185, 0, 0, 255], [185, 0, 0, 255], [183, 0, 0, 255], [183, 0, 0, 255], [181, 0, 0, 255], [180, 0, 0, 255], [179, 0, 0, 255], [178, 0, 0, 255], [177, 0, 0, 255], [175, 0, 0, 255], [174, 0, 0, 255], [174, 0, 0, 255], [172, 0, 0, 255], [171, 0, 0, 255], [169, 0, 0, 255], [169, 0, 0, 255], [168, 0, 0, 255], [166, 0, 0, 255]];
export const RVP6_HOMEYER_LEFTPAD = 30;
export const RVP6_LANG = [[229, 211, 247, 0], [228, 210, 247, 4], [225, 208, 246, 8], [223, 206, 246, 12], [220, 204, 246, 17], [219, 203, 246, 21], [218, 202, 246, 25], [215, 199, 245, 29], [213, 198, 245, 34], [210, 196, 245, 38], [209, 195, 245, 42], [208, 194, 245, 46], [205, 191, 244, 51], [203, 190, 244, 55], [200, 188, 244, 59], [199, 187, 244, 63], [198, 185, 243, 68], [195, 183, 243, 72], [193, 183, 243, 76], [189, 181, 243, 80], [188, 180, 243, 85], [186, 179, 243, 89], [183, 178, 242, 93], [181, 177, 242, 97], [177, 175, 242, 102], [176, 174, 242, 106], [174, 173, 242, 110], [171, 172, 241, 114], [169, 171, 241, 119], [165, 169, 241, 123], [164, 168, 241, 127], [162, 168, 241, 131], [159, 166, 241, 136], [157, 165, 241, 140], [154, 165, 240, 144], [153, 166, 240, 148], [152, 166, 240, 153], [149, 167, 240, 157], [148, 167, 240, 161], [146, 167, 240, 165], [144, 168, 240, 170], [143, 168, 240, 174], [141, 169, 239, 178], [140, 169, 239, 182], [137, 170, 239, 187], [136, 170, 239, 191], [135, 170, 239, 195], [132, 171, 239, 199], [131, 171, 239, 204], [128, 172, 238, 208], [127, 172, 238, 212], [126, 174, 238, 216], [123, 176, 238, 221], [122, 177, 238, 225], [120, 179, 238, 229], [118, 180, 238, 233], [117, 181, 238, 238], [115, 183, 238, 242], [113, 184, 238, 246], [111, 186, 238, 250], [109, 187, 238, 255], [108, 188, 238, 255], [106, 190, 237, 255], [104, 191, 237, 255], [102, 193, 237, 255], [101, 194, 237, 255], [99, 195, 237, 255], [97, 198, 237, 255], [95, 200, 237, 255], [93, 203, 237, 255], [92, 205, 237, 255], [90, 207, 237, 255], [88, 210, 237, 255], [86, 212, 237, 255], [84, 216, 237, 255], [83, 217, 237, 255], [81, 219, 237, 255], [79, 223, 237, 255], [77, 224, 237, 255], [75, 228, 237, 255], [73, 230, 237, 255], [72, 231, 237, 255], [70, 235, 237, 255], [69, 237, 236, 255], [84, 237, 219, 255], [91, 237, 210, 255], [98, 237, 202, 255], [113, 237, 184, 255], [120, 237, 176, 255], [134, 237, 159, 255], [142, 237, 150, 255], [149, 237, 141, 255], [164, 237, 124, 255], [171, 237, 116, 255], [185, 237, 98, 255], [193, 237, 90, 255], [200, 237, 81, 255], [214, 237, 64, 255], [222, 237, 55, 255], [236, 237, 38, 255], [237, 235, 37, 255], [236, 233, 36, 255], [236, 230, 34, 255], [235, 228, 33, 255], [235, 224, 31, 255], [234, 222, 30, 255], [234, 220, 29, 255], [233, 216, 27, 255], [233, 214, 26, 255], [232, 211, 24, 255], [232, 209, 23, 255], [231, 207, 22, 255], [231, 203, 20, 255], [230, 201, 19, 255], [230, 197, 17, 255], [229, 196, 16, 255], [229, 194, 15, 255], [227, 189, 14, 255], [226, 187, 14, 255], [224, 182, 14, 255], [223, 180, 14, 255], [221, 177, 13, 255], [219, 173, 13, 255], [218, 170, 13, 255], [216, 166, 12, 255], [215, 163, 12, 255], [214, 161, 12, 255], [211, 156, 12, 255], [210, 154, 11, 255], [208, 149, 11, 255], [207, 147, 11, 255], [206, 144, 11, 255], [204, 140, 10, 255], [202, 138, 10, 255], [200, 134, 10, 255], [199, 131, 10, 255], [198, 129, 9, 255], [195, 125, 9, 255], [194, 123, 9, 255], [192, 119, 9, 255], [191, 117, 8, 255], [190, 115, 8, 255], [187, 111, 8, 255], [186, 109, 8, 255], [184, 105, 7, 255], [183, 103, 7, 255], [182, 101, 7, 255], [179, 97, 7, 255], [178, 95, 7, 255], [176, 91, 6, 255], [175, 89, 6, 255], [173, 87, 6, 255], [171, 84, 6, 255], [170, 82, 6, 255], [167, 79, 5, 255], [166, 77, 5, 255], [165, 75, 5, 255], [163, 72, 5, 255], [162, 70, 5, 255], [159, 67, 4, 255], [158, 65, 4, 255], [157, 63, 4, 255], [154, 60, 4, 255], [153, 58, 4, 255], [151, 55, 4, 255], [150, 53, 3, 255], [148, 52, 3, 255], [146, 49, 3, 255], [145, 48, 3, 255], [142, 45, 3, 255], [141, 44, 3, 255], [140, 42, 3, 255], [137, 40, 2, 255], [136, 38, 2, 255], [134, 36, 2, 255], [133, 34, 2, 255], [131, 33, 2, 255], [129, 30, 2, 255], [128, 29, 2, 255], [125, 26, 1, 255], [124, 25, 1, 255], [123, 24, 1, 255], [120, 21, 1, 255]];
export const RVP6_LANG_LEFTPAD = 30;

export const LightningColors = [
  "#ffffcc",
  "#fffec9",
  "#fffdc6",
  "#fffcc4",
  "#fffac1",
  "#fff9be",
  "#fff8bb",
  "#fff7b9",
  "#fff5b5",
  "#fff4b2",
  "#fff3af",
  "#fff2ac",
  "#fff1a9",
  "#fff0a7",
  "#ffefa4",
  "#ffeda0",
  "#ffec9d",
  "#ffea9b",
  "#ffe998",
  "#ffe895",
  "#ffe793",
  "#ffe590",
  "#ffe48d",
  "#fee289",
  "#fee187",
  "#fee084",
  "#fede82",
  "#fedd7f",
  "#fedc7c",
  "#fedb7a",
  "#fed976",
  "#fed673",
  "#fed470",
  "#fed16e",
  "#fecf6b",
  "#fecc68",
  "#feca66",
  "#fec863",
  "#fec45f",
  "#fec15d",
  "#febf5a",
  "#febd57",
  "#feba55",
  "#feb852",
  "#feb54f",
  "#feb24c",
  "#feaf4b",
  "#fead4a",
  "#feab49",
  "#fea848",
  "#fea647",
  "#fea446",
  "#fea145",
  "#fd9e43",
  "#fd9c42",
  "#fd9941",
  "#fd9740",
  "#fd953f",
  "#fd923e",
  "#fd903d",
  "#fd8c3c",
  "#fd883b",
  "#fd8439",
  "#fd8038",
  "#fd7c37",
  "#fd7836",
  "#fd7435",
  "#fd7034",
  "#fc6a32",
  "#fc6631",
  "#fc6330",
  "#fc5f2f",
  "#fc5b2e",
  "#fc572c",
  "#fc532b",
  "#fc4d2a",
  "#fa4a29",
  "#f84628",
  "#f74327",
  "#f54026",
  "#f43d25",
  "#f23924",
  "#f13624",
  "#ee3122",
  "#ed2e21",
  "#eb2b21",
  "#e92720",
  "#e8241f",
  "#e6211e",
  "#e51e1d",
  "#e2191c",
  "#e0181d",
  "#dd161d",
  "#db141e",
  "#d9131f",
  "#d6111f",
  "#d41020",
  "#d10e21",
  "#ce0c22",
  "#cb0a22",
  "#c90823",
  "#c70723",
  "#c40524",
  "#c20325",
  "#c00225",
  "#bb0026",
  "#b70026",
  "#b40026",
  "#b00026",
  "#ac0026",
  "#a80026",
  "#a40026",
  "#a10026",
  "#9b0026",
  "#970026",
  "#930026",
  "#8f0026",
  "#8b0026",
  "#880026",
  "#840026",
  "#7e0025",
];

export const precipTypeNames = {
  hail: "ff0000",
  graupel: "ff9900",
  sleet: "00ff00",
  snow: "ffff00",
  rain: "0000ff",
  drizzle: "87CFEB",
  "n/a": "787878",
};
